import { HandCoinOutlineIcon } from './HandCoinOutlineIcon';

/**
 * author: Jeff Anders
 * id 11B36B9E-D054-4A10-996E-62F897EF12C7
 * name hand-coin-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hand-coin-outline.svg
 * tags
 * - Banking 
 */
export const CharityOutlineIcon = HandCoinOutlineIcon;
export default CharityOutlineIcon